import { useState } from 'react';
import { Info, ChevronDown } from 'lucide-react';
import { Card } from './card';

interface RiskDisclosureProps {
  title: string;
  description: React.ReactNode;
  expandableContent?: React.ReactNode;
  defaultExpanded?: boolean;
  expandLabel?: string;
  collapseLabel?: string;
}

export function RiskDisclosure({
  title,
  description,
  expandableContent,
  defaultExpanded = false,
  expandLabel = 'View Full Risk Disclosure',
  collapseLabel = 'Show Less',
}: RiskDisclosureProps) {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  return (
    <Card className="p-4 border-[#E0E0E0] bg-[#F0F0F0]">
      <div className="flex gap-3">
        <Info className="w-5 h-5 text-[#6B6B6B] flex-shrink-0 mt-0.5" />
        <div>
          <h4 className="text-sm font-semibold text-[#242424] mb-2">{title}</h4>
          <div className="text-xs text-muted-foreground leading-relaxed">
            {description}
          </div>
          {expandableContent && isExpanded && (
            <div className="mt-2">{expandableContent}</div>
          )}
          {expandableContent && (
            <button
              onClick={() => setIsExpanded(!isExpanded)}
              className="text-xs text-[#242424] hover:underline flex items-center gap-1 mt-2"
            >
              {isExpanded ? collapseLabel : expandLabel}
              <ChevronDown
                className={`w-3 h-3 transition-transform ${isExpanded ? 'rotate-180' : ''}`}
              />
            </button>
          )}
        </div>
      </div>
    </Card>
  );
}
